module.exports = __webpack_public_path__ + "icon-share-4cbca6af639ba1ed0f72b4a37e5dbd35.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/bundles/ui/ShareButton/icon-share.svg
// module id = 1960
// module chunks = 6